import { clampHighlightZoom } from '@/utils/fileHighlights';

/** Width inside a text, Word, or sheet scrollport after its padding. */
export function flowContentBoxWidth(host: HTMLElement): number {
  const style = getComputedStyle(host);
  const padLeft = Number.parseFloat(style.paddingLeft) || 0;
  const padRight = Number.parseFloat(style.paddingRight) || 0;
  return Math.max(0, host.clientWidth - padLeft - padRight);
}

/**
 * Fit-to-width for flow previews. Wrapping text already matches the pane, so
 * the result stays 1. A wider sheet scales like a PDF page, including the
 * same 50–300% limits. Ratios within 2% of 1 stay at 100%.
 */
export function flowFitZoom(availableWidth: number, contentWidth: number): number {
  if (!(availableWidth > 0) || !(contentWidth > 0)) return 1;
  const raw = availableWidth / contentWidth;
  if (Math.abs(raw - 1) <= 0.02) return 1;
  return clampHighlightZoom(raw);
}
